let capturedElements = [];
let scrollMarkers = [];

class ScrollMarkers {
    constructor(element) {
        this.element = element;
		this.scrollContainer = this.element.parentElement;
        this.markers = [];

        this.init();
    }

    init() {
		console.log('init')
		const elementPosition = this.element.style.position;

		if (elementPosition !== 'absolute' || elementPosition !== 'relative') {
			this.element.style.position = 'relative';
		}
		
		this.drawOverflowMarkers();
        this.initScrollObserver();
    }

    drawOverflowMarkers() {
        const startMarker = document.createElement('div');
        const startMarkerStyles = {
            display: 'flex',
            order: -1,
            width: '1px',
            height: '1px',
            minHeight: '1px',
            visibility: 'hidden',
        };

        const endMarker = document.createElement('div');
        const endMarkerStyles = {
			display: 'flex',
			order: 100,
            width: '1px',
            height: '1px',
            minHeight: '1px',
            visibility: 'hidden',
        };

        endMarker.setAttribute('data-marker-position', 'end');
        startMarker.setAttribute('data-marker-position', 'start');

        Object.assign(startMarker.style, startMarkerStyles);
        Object.assign(endMarker.style, endMarkerStyles);

        this.element.appendChild(startMarker);
        this.element.appendChild(endMarker);

        this.markers.push(startMarker, endMarker);
    }

    initScrollObserver() {
        const options = {
            threshhold: 1,
        };

        const observerHandler = (entries, observer) => {
            entries.forEach(entry => {
                const markerPosition = entry.target.dataset.markerPosition;
                const dataAttributeName = `data-${markerPosition}-marker`;

                if (entry.isIntersecting) {
                    this.scrollContainer.setAttribute(dataAttributeName, 'hide');
                } else {
                    this.scrollContainer.setAttribute(dataAttributeName, 'show');
                }
            });
        };

        const observer = new IntersectionObserver(observerHandler, options);

        this.markers.forEach(marker => {
            observer.observe(marker);
        });
    }
}

export const addScrollMarkers = element => {
    capturedElements.push(element);
    scrollMarkers.push(new ScrollMarkers(element));
};

export default init = (target = document) => {
    if (typeof jweather === 'undefined') {
        return;
    }

    const targetElements = [...target.querySelectorAll('[data-scroll-markers]')];
    const dedupedTargetElements = targetElements.filter(targetElement => !capturedElements.find(capturedElement => targetElement === capturedElement));

    if (dedupedTargetElements.length === 0) return;

    dedupedTargetElements.forEach(element => {
        addScrollMarkers(element);
    });
};
